import React, { useEffect, useState } from "react";
import cssClasses from "../KYCAgreementForm.module.css";
import { Tab, Tabs } from "@mui/material";
import Button from "../../../Subcomponents/Button";
import PlusIcon from "../../Icons/PlusIcon";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { errorTost, successTost } from "../../../Services/Toast";
import {
  deleteBankFromServer,
  getBankDetailsFromServer,
  insertBankDetails,
  updateBankDetails,
} from "../../../Services/Bank";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import AddBankDetailsModal from "../AddBankDetailsModal/AddBankDetailsModal";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "../../../Assets/Images/Common/EditIcon.svg";
import { useSelector } from "react-redux";
import NBFCDetails from "../NDFC/NBFCDetails";
import DeleteSvg from "../../../Assets/Images/Common/deleteIcon.svg";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";

export const dataGridStyles = {
  // "&.MuiDataGrid-root": {
  //   width: "min(1200px,100%) !important",
  // },
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },
  "& .MuiDataGrid-columnHeaders + div": {
    height: "calc(100vh - 315px) !important",
  },
  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 2rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 1rem",

    "&:focus": {
      outline: "none",
    },
  },
};

const BankDetails = () => {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [tabValue, setTabValue] = useState("");
  const [tabs, setTab] = useState([]);
  const [allBankData, setAllBankData] = useState([]);
  const [showAddBankDetailsModal, setShowAddBankDetailsModal] = useState(false);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const tabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const tagGridColumns = [
    {
      field: "action",
      headerName: "",
      width: window.innerWidth < 820 ? 50 : 100,
      renderCell: (params) => {
        return (
          <div style={{ cursor: "pointer" }}>
            <img
              src={EditIcon}
              alt="edit"
              onClick={() => {
                setIsEdit(true);
                setSelectedBankDetails(params?.row);
                setShowAddBankDetailsModal(true);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "bankName",
      headerName: "Bank Name",
      width: window.innerWidth < 820 ? 160 : 250,
      renderCell: (params) => {
        return <div>{params?.row?.bankName}</div>;
      },
    },
    {
      field: "IFSCCode",
      headerName: "Bank Ifsc Code",
      width: window.innerWidth < 820 ? 110 : 250,
      renderCell: (params) => {
        return <div> {params?.row?.ifscCode}</div>;
      },
    },

    {
      field: "branchName",
      headerName: "Branch Name",
      width: window.innerWidth < 820 ? 160 : 250,
      renderCell: (params) => {
        return <div>{params?.row?.branchName}</div>;
      },
    },
    {
      field: "city",
      headerName: "City",
      width: window.innerWidth < 820 ? 160 : 250,
      renderCell: (params) => {
        return <div>{params?.row?.city}</div>;
      },
    },
    {
      field: "deleteAction",
      headerName: "",
      width: window.innerWidth < 820 ? 50 : 80,
      renderCell: (params) => {
        return (
          <div style={{ cursor: "pointer" }}>
            <img
              src={DeleteSvg}
              alt="delete"
              onClick={() => {
                setShowDeleteConfirmation(true);
                setSelectedBankDetails(params?.row);
              }}
            />
          </div>
        );
      },
    },
  ];

  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.4rem !important",
            lineHeight: "2rem !important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });

  useEffect(() => {
    const payload = [];
    if (
      loggedInUser?.roleId?.level == 1 ||
      loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.[
        "KYC Agreement Form"
      ]?.["NBFC"]?.isAccessible
    ) {
      payload.push("NBFC");
    }
    if (
      loggedInUser?.roleId?.level == 1 ||
      loggedInUser?.roleId?.accessibleTabs?.["Settings"]?.["Masters"]?.[
        "KYC Agreement Form"
      ]?.["Bank"]?.isAccessible
    ) {
      payload.push("Bank");
    }
    setTab(payload);
    setTabValue(payload[0]);
  }, [loggedInUser]);

  useEffect(() => {
    getFilterBanksPagination();
  }, []);

  async function getFilterBanksPagination() {
    //setAllAllotments([])
    await getBankDetailsFromServer()
      .then((getBankDetails) => {
        setAllBankData([]);
        setAllBankData((pre) => [
          ...getBankDetails?.data?.map((v) => {
            return {
              ...v,
              id: v?.bankId,
            };
          }),
        ]);
        dismissLoader();
        return getBankDetails?.data;
      })
      .catch((err) => {
        dismissLoader();
        if (err?.message) {
          errorTost(err?.message);
        } else {
          errorTost("Something went wrong! Try again");
        }
      });
  }

  const handleInsertBankDetails = (val, isUpdate) => {
    presentLoader();
    if (isUpdate) {
      const payload = {
        bankName: val?.bankName,
        ifscCode: val?.ifscCode,
        branchName: val?.branchName,
        city: val?.city,
        last_updated_at: new Date().getTime(),
      };
      updateBankDetails(payload, selectedBankDetails?.bankId)
        .then((resp) => {
          dismissLoader();
          setSelectedBankDetails(null);
          successTost("Bank updated successfully!");
          getFilterBanksPagination();
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
    } else {
      insertBankDetails(val)
        .then((resp) => {
          dismissLoader();
          successTost("Bank inserted successfully!");
          getFilterBanksPagination();
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
    }
  };

  const handleDeleteBank = () => {
    presentLoader();
    deleteBankFromServer(selectedBankDetails?.bankId)
      .then((resp) => {
        dismissLoader();
        setSelectedBankDetails(null);
        successTost("Bank deleted successfully!");
        getFilterBanksPagination();
      })
      .catch((err) => {
        dismissLoader();
        if (err.message.includes("update or delete")) {
          errorTost("Bank is linked at agreement form so unable to delete this record!");
        } else {
          errorTost(err.message);
        }
      });
  };
  return (
    <div className={cssClasses.wrapperPage}>
      <Tabs
        value={tabValue}
        onChange={tabChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        sx={[
          {
            borderBottom: "1px solid #EAECF0 !important",
          },
        ]}
      >
        {tabList}
      </Tabs>

      <div className={cssClasses.wrapperContent}>
        {tabValue === "Bank" && (
          <div className={cssClasses.wrapperSubContent}>
            <div className={cssClasses.addButton}>
              <Button
                style={{
                  color: "#FFFFFF",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  width: "17rem",
                }}
                btnIcon={<PlusIcon />}
                iconPosition={"left"}
                btnName={"Add Bank"}
                clicked={() => {
                  setIsEdit(false);
                  setSelectedBankDetails(null);
                  setShowAddBankDetailsModal(true);
                }}
              />
            </div>
            <div style={{ margin: "1rem" }}>
              {allBankData?.length > 0 ? (
                <DataGrid
                  rows={allBankData}
                  columns={tagGridColumns}
                  hideFooterPagination={false}
                  hideFooter={false}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  sx={[dataGridStyles]}
                  disableColumnFilter
                  disableColumnMenu
                  disableColumnSelector
                  disableDensitySelector
                  disableSelectionOnClick
                  disableVirtualization
                />
              ) : (
                <div style={{ height: "400px" }}>
                  <p
                    style={{
                      position: "relative",
                      top: "50%",
                      textAlign: "center",
                      fontSize: "3rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <img src={EmptyState} alt="No Data" />
                      <span>No Record Available</span>
                    </div>
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
        {tabValue === "NBFC" && <NBFCDetails />}
      </div>
      {showAddBankDetailsModal && (
        <AddBankDetailsModal
          open={showAddBankDetailsModal}
          handleClose={() => {
            setShowAddBankDetailsModal(false);
          }}
          isEdit={isEdit}
          selectedBank={selectedBankDetails}
          handleSave={(val, isUpdate, isDeleted) => {
            if (
              selectedBankDetails?.branchName === val?.branchName &&
              selectedBankDetails?.ifscCode === val?.ifscCode &&
              selectedBankDetails?.bankName === val?.bankName &&
              selectedBankDetails?.city === val?.city
            ) {
              setShowAddBankDetailsModal(false);
            } else {
              if(!isDeleted){
              setShowAddBankDetailsModal(false);
              handleInsertBankDetails(val, isUpdate);
              }
            }

            if (isDeleted) {
              setShowAddBankDetailsModal(false);
              setShowDeleteConfirmation(true);
            }
          }}
        />
      )}
      {showDeleteConfirmation && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              handleDeleteBank();
            }
            setShowDeleteConfirmation(false);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Delete"}
          close={() => setShowDeleteConfirmation(false)}
          title={"Warning"}
          subTitle={`Are you sure you want to delete this ?`}
          open={showDeleteConfirmation}
        />
      )}
    </div>
  );
};

export default BankDetails;
